import * as React from "react";
import { ArrowLink, ARROW_LINK_DIRECTION } from "./components/ArrowLink";

export const NavigatorChart = ({
  monthRange,
  onChange,
  currentSlide,
  shouldShowNavigation
}: {
  currentSlide: number;
  monthRange: string;
  onChange: (isRightArrow: boolean) => (e: MouseEvent) => void;
  shouldShowNavigation: boolean;
}) => (
  <div className="uitk-grid all-b-padding-four all-t-padding-three">
    {shouldShowNavigation && (
      <ArrowLink
        direction={ARROW_LINK_DIRECTION.LEFT}
        onClick={onChange}
        disabled={!currentSlide}
      />
    )}
    <span
      className={`uitk-cell all-y-padding-two centerText all-cell-${
        shouldShowNavigation ? "2-3" : "1-1"
      }`}
    >
      {monthRange}
    </span>
    {shouldShowNavigation && (
      <ArrowLink
        direction={ARROW_LINK_DIRECTION.RIGHT}
        onClick={onChange}
        disabled={!!currentSlide}
      />
    )}
  </div>
);
